var map = {
	"./apply/lucky/wheel/wheel.vue": [
		3768,
		768
	],
	"./debug/debug.vue": [
		2248,
		165,
		248
	],
	"./home/home.vue": [
		708,
		21,
		964
	],
	"./merits/merits.vue": [
		3379,
		379
	],
	"./mine/mine.vue": [
		1471,
		471
	],
	"./promotion/create/create.vue": [
		8283,
		165,
		283
	],
	"./promotion/index/index.vue": [
		8552,
		21,
		926
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;